import React, { Fragment, useEffect, useState } from "react";
import { Container, Row, Col, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import { Breadcrumbs, H3, H2 } from "../../../AbstractElements";
import GreetingCard from "./GreetingCard";
import WidgetsWrapper from "./WidgetsWraper";
import ChartsWrapper from "./ChartsWraper.jsx";
import NotificationsPanel2 from './NotificationPanel2';
import Loader from "../../../CommonElements/Loader/loader.jsx";
import { getDashboardData } from '../../../api-handle/dashboardApi';
import { Star } from "lucide-react";

const Dashboard = () => {
  const [dashboardData, setDashboardData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [timePeriod, setTimePeriod] = useState("monthly"); // Default to monthly
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const toggleDropdown = () => setDropdownOpen(prevState => !prevState);

  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        setLoading(true);
        const data = await getDashboardData({ mode: timePeriod });
        setDashboardData(data?.data);
      } catch (error) {
        console.error("Failed to fetch dashboard data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchDashboardData();
  }, [timePeriod]);

  if (loading && !dashboardData) {
    return <Loader />;
  }

  return (
    <Fragment>
      <Breadcrumbs mainTitle="Stats" parent="Dashboard" title="Stats" />
      <Container fluid={true}>

        <Row className="widget-grid">
          <GreetingCard />
          {dashboardData?.summary && <WidgetsWrapper data={formatSummaryData(dashboardData.summary)} />}
          <NotificationsPanel2 data={dashboardData?.notifications || []} />
          <div className="row mb-3" style={{ justifyContent: 'flex-end' }}>
            <div className="col-auto">
              <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
                <DropdownToggle
                  caret
                  style={{
                    backgroundColor: '#33bdbf',
                    border: 'none',
                    borderRadius: '8px',
                    padding: '8px 16px',
                    fontSize: '14px',
                    fontWeight: '500',
                    color: '#ffffff',
                    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                    minWidth: '140px',
                  }}
                >
                  {timePeriod.charAt(0).toUpperCase() + timePeriod.slice(1)} View
                </DropdownToggle>
                <DropdownMenu end>
                  {['daily', 'weekly', 'monthly'].map((p) => (
                    <DropdownItem
                      key={p}
                      active={timePeriod === p}
                      onClick={() => setTimePeriod(p)}
                    >
                      {p.charAt(0).toUpperCase() + p.slice(1)}
                    </DropdownItem>
                  ))}
                </DropdownMenu>
              </Dropdown>
            </div>
          </div>
          {loading ? <Loader /> : <ChartsWrapper
            dashboardData={dashboardData}
            loading={loading}
            timePeriod={timePeriod}
          />}
        </Row>
      </Container>
    </Fragment>
  );
};

// Helper function to format summary data for widgets
const formatSummaryData = (summary) => [
  {
    title: "Total Subscriptions Sold",
    total: summary.totalSubscriptionsSold ?? "0",
    icon: "fill-calender",
    color: "primary",
  },
  {
    title: "Total Classes Booked",
    total: summary.totalClassesBooked ?? "0",
    icon: "tag",
    color: "success",
  },
  {
    title: "Total Completed Orders",
    total: summary.totalCompletedOrders ?? "0",
    icon: "cart",
    color: "warning",
  },
  {
    title: "Total Pending Payments",
    total: summary.totalPendingPayments ?? "0",
    icon: "clock",
    color: "danger",
  },
  {
    title: "Total Reviews & Ratings",
    total: summary.totalReviews ?? "0",
    icon: "star",
    color: "info",
    useOtherIcon: true,
    otherIcon: <Star />
  },
];

export default Dashboard;